import { render, staticRenderFns } from "./exerciceForm.vue?vue&type=template&id=0180be30&"
import script from "./exerciceForm.vue?vue&type=script&lang=js&"
export * from "./exerciceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports